import { startApp } from '@/common/preload/startApp';
import { clearDataAfterLogout } from '@/common/preload/offApp';
import LoginPage from '@/views/Login/LoginPage';
import Page404 from '@/views/Page404';

export default [
  {
    path: '*',
    name: '404',
    component: Page404,
  },
  {
    path: '/login',
    name: 'Login',
    alias: '/verify-sign-in',
    component: LoginPage,
    beforeEnter: (to, from, next) => {
      localStorage.removeItem('prescribeToken');
      next();
    },
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: () => import(/* webpackChunkName: "forgot-password-page" */ '@/views/ForgotPassword/ForgotPasswordPage'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/check-eligibility',
    name: 'CheckEligibility',
    component: () => import(/* webpackChunkName: "check-eligibility-page" */ '@/views/CheckEligibility/EligibilityPage'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import(/* webpackChunkName: "registration-page" */ '@/views/Registration/RegistrationPage'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/confirmpassword',
    name: 'ConfirmPassword',
    component: () => import(/* webpackChunkName: "confirm-password-page" */ '@/views/ConfirmPassword/ConfirmPasswordPage'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/confirmation',
    name: 'Confirmation',
    component: () => import(/* webpackChunkName: "confirmation-page" */ '@/views/Confirmation/ConfirmationPage'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/invitee-confirmation',
    name: 'InviteeConfirmation',
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
    redirect: { name: 'Invitee' },
  },
  {
    path: '/invitee',
    // path: '/invitee/:roomId/:appointmentId',
    name: 'Invitee',
    component: () => import(/* webpackChunkName: "invitee" */ '@/views/VideoCall/Invitee'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/epic/:type',
    name: 'Epic',
    component: () => import(/* webpackChunkName: "epic" */ '@/views/VideoCall/Epic'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/termsandconditions',
    name: 'TermsAndConditions',
    component: () => import(/* webpackChunkName: "terms-and-conditions" */ '@/views/StaticPages/TermsAndConditions'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/privacypolicy',
    name: 'PrivacyPolicy',
    component: () => import(/* webpackChunkName: "privacy-policy" */ '@/views/StaticPages/PrivacyPolicy'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import(/* webpackChunkName: "faq" */ '@/views/StaticPages/Faq'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/sso-auth',
    name: 'Sso',
    beforeEnter: async (to, from, next) => {
      const { accessToken, refreshToken } = to.query;
      if (accessToken) {
        try {
          await clearDataAfterLogout();
          localStorage.setItem('token', accessToken);
          localStorage.setItem('refreshToken', refreshToken);
          await startApp();
          sessionStorage.setItem('isLoggedIn', 'true');
          next('/');
        } catch (e) {
          console.error(e);
          next('/login');
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
        }
      } else {
        next('/login');
      }
    },
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
  {
    path: '/ui',
    name: 'Ui',
    component: () => import(/* webpackChunkName: "ui" */ '@/views/Ui/Ui'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
    children: [
      {
        path: 'icons',
        name: 'UiIcons',
        component: () => import(/* webpackChunkName: "ui-icons" */ '@/views/Ui/views/icons/Icons'),
        meta: {
          appElementSettings: ['hideSidebar', 'hideToolbar'],
        },
      },
    ],
  },
  {
    // this router use mobile application for webView. Don't change the route path
    path: '/pillar-form',
    name: 'PillarForm',
    component: () => import(/* webpackChunkName: "pillar-form" */ '@/components/shared/Payment/PillarCardForm'),
    meta: {
      appElementSettings: ['hideSidebar', 'hideToolbar'],
    },
  },
];
